export default __webpack_public_path__ + "static/media/iceland_mtn-9518.ec0e9f3a.jpg";